/** Eventos de soporte que el comercio no debe ver en historial de actividad. */
export function isHiddenFromCommerceAuditEvent(eventType: string): boolean {
  return eventType.startsWith('support.impersonation');
}

export function isImpersonationLogoutReason(reason?: string): boolean {
  return reason === 'impersonation_ended' || reason === 'impersonation_expired';
}
